<template>
    <div
        class="selector"
        :class="opened ? 'selector-opened' : ''"
        @click="dropDownToggle()"
    >
        <div class="selector-input">
            <input
                autocomplete="off"
                data-lpignore="true"
                data-form-type="other"
                ref="selectorInput"
                v-model="selectorInput"
                v-on:focus="typing = true"
                :placeholder="this.selectPlaceholder"
            />
            <div class="fa fa-chevron-down"></div>
        </div>
        <div class="selector-dropdown" v-if="opened">
            <div class="selector-dropdown-container">
                <div
                    v-bind:value="option.id"
                    v-bind:key="option.id"
                    v-for="option in options"
                    v-html="optionLabel(option)"
                    v-on:click="select(option)"
                    :class="
                        option.separator === true
                            ? 'selector-separator'
                            : 'selector-option'
                    "
                ></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            options: [],
            opened: false,
            selected: null,
            selectorInput: '',
            selectPlaceholder: null,
            typing: false,
        };
    },

    watch: {
        typing(value) {
            this.filterOptions();
        },
    },

    methods: {
        dropDownToggle() {
            if (!this.opened) {
                this.opened = true;
                this.$refs.selectorInput.focus();
                this.filterOptions();
            } else {
                this.opened = false;
                this.$refs.selectorInput.blur();
            }
        },

        filterOptions() {
            // To override...
        },

        select() {
            this.typing = false;
        },
    },
};
</script>
